import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { AccountingEventsRepository } from '@core/repositories/accounting-events.repository';
import { AccountingEvent } from '@shared/interfaces/accounting-event';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiAccountingEventsRepository implements AccountingEventsRepository {
  public url = this.appConfig.URL + '/amlcontrol/v1/rules/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(rule: AccountingEvent): Observable<any> {
    const data = {
      data: {
        id: rule.id,
        type: 'AccountingEvent',
        attributes: {
          name: rule.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(rule: AccountingEvent): Observable<any> {
    const data = {
      data: {
        id: rule.id,
        type: 'AccountingEvent',
        attributes: {
          name: rule.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
